// App.js
import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes, useLocation, useNavigate } from 'react-router-dom';
// import { ThemeProvider } from 'styled-components';

// Import your existing components
import Login from './component/loginPage/Login';
import Signup from './component/loginPage/Signup';
import ForgotPassword from './component/loginPage/ForgotPassword';
import ResetPassword from './component/loginPage/ResetPassword';
import BillingPage from './component/loginPage/BillingPage';
import { AuthProvider, useAuth } from './authorize/AuthContext';
import ProtectedRoute from './authorize/ProtectedRoute';
import { DataProvider } from './authorize/DataContext';
import OnboardingInputUserData from './component/onboardingPage/OnboardingUserData';
import CampaignInitialize2 from './component/onboardingPage/OnboardingSelectDataFill2';
import CampManualFill from './component/onboardingPage/OnboardingCampManualFill';
import OnboardingReviewCampaign from './component/onboardingPage/OnboardingReviewCampaign';
import OnboardingCampaignMatching from './component/onboardingPage/OnboardingMatching';
import UserAIChatUI from './component/onboardingPage/OnboardingAIChat3';
import DashboardPage from './component/managingPage/DashboardNewPage';
import MyCampaign from './component/managingPage/MyCampaign';
import NewCampaign from './component/managingPage/createCampaign';
import UpdateCampaign from './component/managingPage/updateCampaign';
import AddMatchingCompany from './component/managingPage/addMatchingCompany';
import EmailStatus from './component/mailPage/emailStatus2';
import ViewInsight from './component/mailPage/ViewInsight2';
import Unibox from './component/mailPage/Unibox';
import CompletePayment from './component/banking/completePayment';
import Account from './component/oldaccount/account';
import OAuthCallback from './component/loginPage/OAuthCallback';
import ProspectsPage from './component/oldcampaign/ProspectsPage';
// import UploadVoice from './component/campaign/UploadVoicePopUp';
import CampaignsStatus from './component/campaign/CampaignStatus';
import ContactUs from './component/homepage/ContactUs';
import AboutUsPage from './component/homepage/AboutUsPage';
// import theme from './theme';
import BlogPage from './component/homepage/BlogPage';
import ApiDocsPage from './component/homepage/ApiDocsPage';
import HelpCenterPage from './component/homepage/HelpCenterPage';
import PrivacyPolicyPage from './component/homepage/PrivacyPolicyPage';
import TermsOfServicePage from './component/homepage/TermsOfServicePage';
import CareersPage from './component/homepage/CareersPage';
import AccountPage from './component/account/UserAccount';
import CampaignDashboardPage from './component/outreach/CampaignDashboardPage';
import NewBillingPage from './component/loginPage/NewBiilingPage';
// Import the new HomePage and its theme dependencies
import HomePage from './component/homepage/HomePage' // Assuming HomePage.js is in src/pages/
// import  theme  from './theme'; // Assuming theme.js is in src/
// import GlobalStyle from './GlobalStyle'; // The file you just created
import PricingPage from './component/account/Pricing';

import AutopilotPage from './component/autopilot/AutopilotDesign';
import BookMeetingPage from './component/autopilot/BookMeeting';
import Dashboard from './component/managingPage/Dashboard';
import PageNotFound from "./component/PageNotFound/PageNotFound"
import GoogleCallback from './component/loginPage/GoogleCallback';
import HomeNew from "./component/homepage/HomeNew"

import AOS from 'aos';
import 'aos/dist/aos.css';
import EmailStatus3 from './component/mailPage/EmailStatus3';
import  Breadcrumbs from './component/breadCrumb/breadcrumb';
import LandingPage from './component/mortgage/LandingPage';
import Domain from './component/campaign/Domain';
import DomainEmail from './component/campaign/DomainEmail';

const PROTECTED_PATHS = [
  '/onboarding-userinfo',
  '/campinitselect',
  '/campfill',
  '/onboardingcampmatch',
  '/reviewinfo',
  '/useraichat',
  '/new-campaign',
  '/dashboard',
  '/dashboard-new',
  '/my-campaign',
  '/update-campaign',
  '/viewinsight',
  '/unibox',
  '/addmatching',
  '/successpayment',
  '/prospects',
  '/campaignstatus',
  '/outreach',
  '/account',
  '/emailstatus3',
  '/domain',
  '/domain-email',
];

const GlobalBanner = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { billingPlan, hasSmtpIntegration } = useAuth();

  const isProtectedPage = PROTECTED_PATHS.some(
    (p) => location.pathname === p || location.pathname.startsWith(p + '/')
  );

  if (!isProtectedPage) return null;
  if (location.pathname === '/email-status') return null;
  if (billingPlan?.toLowerCase() !== 'enterprise') return null;
  if (hasSmtpIntegration) return null;

  return (
    <div
      onClick={() => navigate('/domain-email')}
      style={{
        position: 'fixed',
        bottom: '8px',
        left: '6px',
        fontSize: '13px',
        color: '#fff',
        background: 'linear-gradient(135deg, #f59e0b, #ef4444)',
        padding: '10px 16px',
        borderRadius: '8px',
        boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
        cursor: 'pointer',
        zIndex: 9999,
        maxWidth: '320px',
        lineHeight: '1.4',
      }}
    >
      ⚠️ <strong>Action Required:</strong> Domain &amp; Email Integration is pending. Please complete the setup to start outreach.
    </div>
  );
};

const App = () => {
  useEffect(() => {
    AOS.init();
  },);

  // useEffect(() => {
  //   if (document.getElementById('hs-script-loader')) return;

  //   const script = document.createElement('script');
  //   script.id = 'hs-script-loader';
  //   script.src = 'https://js-na2.hs-scripts.com/243630945.js';
  //   script.async = true;
  //   script.defer = true;
  //   document.body.appendChild(script);
  // }, []);

  // useEffect(() => {
  //   // Offset HubSpot chat widget ~30px from the bottom updating the code again as chnages are not refelcted
  //   const style = document.createElement('style');
  //   style.id = 'hs-chat-offset';
  //   style.textContent = `
  //       /* HubSpot Conversations launcher */
  //       #hubspot-messages-iframe-container,
  //       [id^="hubspot-messages-iframe-container"] {
  //         bottom: 60px !important;
  //       }
  //       /* (Optional) Legacy/other HubSpot widget containers */
  //       .hs-widget-container {
  //         bottom: 60px !important;
  //       }
  //     `;
  //   document.head.appendChild(style);

  //   return () => {
  //     const s = document.getElementById('hs-chat-offset');
  //     if (s) s.remove();
  //   };
  // }, []);

  const [userData, setUserData] = useState({
    firstName: 'Alice',
    lastName: 'Wonderland',
    email: 'alice.w@example.com',
    type: 'Premium Member',
    bio: 'Software engineer passionate about building beautiful and functional user interfaces. Enjoys hiking, photography, and exploring new technologies.',
    profilePicture: 'https://placehold.co/150x150/A78BFA/ffffff?text=AW',
    billingHistory: []
  });

  const handleProfileSave = (updatedData) => {
    setUserData(prevData => ({ ...prevData, ...updatedData }));
    console.log("Profile updated:", updatedData);
  };

  return (
    <AuthProvider>
      <DataProvider>
        <Router>
          <Routes>
            {/* Route for the new HomePage */}
            {/* <Route 
              path="/" 
              element={
                <ThemeProvider theme={theme}>
                  <GlobalStyle />
                  <HomePage />
                </ThemeProvider>
              } 
            /> */}
            <Route path="/" element={<HomeNew />} />

            {/* Your existing application routes */}
            <Route path="/login" element={<Login />} />
            <Route path="/signup" element={<Signup />} />
            <Route path="/forgotpw" element={<ForgotPassword />} />
            <Route path="/resetpw" element={<ResetPassword />} />
            <Route path="/billing" element={<BillingPage />} />
            <Route path="/new/billing" element={<NewBillingPage />} />
            <Route path="/pricing" element={<PricingPage />} />
            <Route path="/contact" element={<ContactUs />} />
            <Route path="/about" element={<AboutUsPage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/apidocs" element={<ApiDocsPage />} />
            <Route path="/helpcenter" element={<HelpCenterPage />} />
            <Route path="/privacypolicy" element={<PrivacyPolicyPage />} />
            <Route path="/termsofservice" element={<TermsOfServicePage />} />
            <Route path="/careers" element={<CareersPage />} />
            <Route path="/onboarding-userinfo" element={<ProtectedRoute><OnboardingInputUserData /></ProtectedRoute>} />
            <Route path="/campinitselect" element={<ProtectedRoute><CampaignInitialize2 /></ProtectedRoute>} />
            <Route path="/campfill" element={<ProtectedRoute><CampManualFill /></ProtectedRoute>} />
            <Route path="/onboardingcampmatch" element={<ProtectedRoute><OnboardingCampaignMatching /></ProtectedRoute>} />
            <Route path="/reviewinfo" element={<ProtectedRoute><OnboardingReviewCampaign /></ProtectedRoute>} />
            <Route path="/useraichat" element={<ProtectedRoute><UserAIChatUI /></ProtectedRoute>} />
            <Route path="/new-campaign" element={<ProtectedRoute><NewCampaign /></ProtectedRoute>} />
            <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
            <Route path="/my-campaign" element={<ProtectedRoute><MyCampaign /></ProtectedRoute>} />
            <Route path="/update-campaign" element={<ProtectedRoute><UpdateCampaign /></ProtectedRoute>} />
            <Route path="/email-status" element={<ProtectedRoute><EmailStatus /></ProtectedRoute>} />
            <Route path="/viewinsight" element={<ProtectedRoute><ViewInsight /></ProtectedRoute>} />
            <Route path="/unibox" element={<ProtectedRoute><Unibox /></ProtectedRoute>} />
            <Route path="/addmatching" element={<ProtectedRoute><AddMatchingCompany /></ProtectedRoute>} />
            <Route path="/successpayment" element={<ProtectedRoute><CompletePayment /></ProtectedRoute>} />
            <Route path="/settings" element={<Account user={userData} onProfileSave={handleProfileSave} />} />
            <Route path="/oauth/callback" element={<OAuthCallback />} />
            <Route
              path="/prospects" element={<ProtectedRoute><ProspectsPage /></ProtectedRoute>} />
            {/* <Route path="/uloadvoice" element={<ProtectedRoute><UploadVoice /></ProtectedRoute>} /> */}
            <Route path="/campaignstatus" element={<ProtectedRoute><CampaignsStatus /></ProtectedRoute>} />
            <Route path="/outreach/test" element={<ProtectedRoute><CampaignDashboardPage /></ProtectedRoute>} />
            <Route path="/account/:section?" element={<ProtectedRoute><AccountPage /></ProtectedRoute>} />
            <Route path="/dashboard-new" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
            <Route path="*" element={<PageNotFound />} />
            <Route path="/auth/google/callback" element={<GoogleCallback />} />
            <Route path="/home" element={<HomePage />} />
            <Route path="/emailstatus3" element={<ProtectedRoute><EmailStatus3 /></ProtectedRoute>} />
            {/* <Route path="/mortgage" element={<LandingPage/>} /> */}
            <Route path="/domain" element={<ProtectedRoute><Domain /></ProtectedRoute>} />
            <Route path="/domain-email" element={<ProtectedRoute><DomainEmail /></ProtectedRoute>} />

            
            {/* For Testing  */}
            {/* <Route path="/autopilot" element={<ProtectedRoute><AutopilotPage /></ProtectedRoute>} /> 
            <Route path="/bookmeeting" element={<ProtectedRoute><BookMeetingPage /></ProtectedRoute>} /> */}
          </Routes>
          <GlobalBanner />
        </Router>
      </DataProvider>
    </AuthProvider>
  );
}

export default App;

